<template>
    <Breadcrumbs main="Bonus Ui" title="Dropzone" />
    <div class="container-fluid">
        <div class="row">
            <defaultDropzone />
            <imageDropzone />
            <singleDropzone />
            <multiDropzone />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
const defaultDropzone = defineAsyncComponent(() => import("@/components/theme/advance/dropzone/defaultDropzone.vue"))
const imageDropzone = defineAsyncComponent(() => import("@/components/theme/advance/dropzone/imageDropzone.vue"))
const singleDropzone = defineAsyncComponent(() => import("@/components/theme/advance/dropzone/singleDropzone.vue"))
const multiDropzone = defineAsyncComponent(() => import("@/components/theme/advance/dropzone/multiDropzone.vue"))
</script>